export default __webpack_public_path__ + "static/media/delivery_icon.94df58ca.svg";